import AccountTransfer from '@advisor/models/store/accountTransfer';
import AccountTransferService from '@advisor/services/AccountTransfer';
import exceptionHandler from '@advisor/util/exceptionHandler';
import RwCustodianService from '@advisor/rwSdk/CustodianService';
import {addRiaComponentTo} from '@advisor/util/store/paramInjects';

const stateObj = () => new AccountTransfer();

const getters = {};

const actions = {
  setActiveTab({commit}, payload) {
    commit('SET_ACTIVE_TAB', payload.activeTab);
  },
  /**
   * This will fetch target account details for showing the chart
   * @param {Object} param0
   * @param {Object} payload Should contain accountId
   *
   * '@returns {Promise}
   */

  async getAggregatorInstitutions({commit, rootState}) {
    try {
      const present = true;
      const fullPayload = addRiaComponentTo({present}, rootState.settings.default);
      const response = await RwCustodianService.getAcatsInstitutions(fullPayload).catch((error) => {
        throw error;
      });

      commit('SET_AGGREGATOR_INSTITUTIONS', response);
    } catch (error) {
      exceptionHandler.handleGenericException('accountTransfer.getAggregatorInstitutions', error);
    }
  },

  async sendEmailRequest(_, payload) {
    try {
      await AccountTransferService.sendEmailRequest(payload);
    } catch (error) {
      exceptionHandler.handleGenericException('accountTransfer.sendEmailRequest', error);
    }
  },

  setupConfirmation({commit}, payload) {
    commit('SETUP_CONFIRMATION', payload);
  },
};

const mutations = {
  SET_ACTIVE_TAB(state, payload) {
    state.activeTab = payload;
  },
  SET_AGGREGATOR_INSTITUTIONS(state, payload) {
    state.aggregatorInstitutions = payload;
  },
  SETUP_CONFIRMATION(state, payload) {
    state.confirmationDetails = payload;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
};
